import { createFileRoute } from "@tanstack/react-router";
import ServiceRevOps from "@/pages/ServiceRevOps";
import {
  buildPageHead,
  breadcrumbSchema,
  serviceSchema,
  faqPageSchema,
} from "@/lib/seo";

const faqs = [
  {
    question: "What is a CRM RevOps Architect?",
    answer:
      "A CRM RevOps Architect engineers the end-to-end CRM and revenue systems that capture, qualify, route, and convert leads automatically — designing pipeline automation, data architecture, and reporting infrastructure that aligns sales, marketing, and service operations.",
  },
  {
    question: "What CRM platforms does Marjohn specialize in?",
    answer:
      "Marjohn specializes in GoHighLevel and HubSpot CRM architecture, with n8n and Make orchestration, custom API automation, and lifecycle pipeline design for agencies, coaches, and multi-location franchises.",
  },
  {
    question: "How much does it cost to hire a CRM RevOps Architect?",
    answer:
      "Engagements are scoped per project or retainer. Marjohn works as a remote contractor paid via low-fee cross-border transfers such as Wise. Book a free strategy call to receive a custom scope and quote for your CRM and RevOps needs.",
  },
  {
    question: "How long does a CRM RevOps engagement take?",
    answer:
      "Depending on scope, a fully automated CRM and revenue operations system can be architected and deployed within days to a few weeks, with 300+ live systems already running for clients across four countries.",
  },
];

export const Route = createFileRoute("/CRM-revops-architect")({
  head: () =>
    buildPageHead({
      title: "CRM RevOps Architect | Marjohn Robillo",
      description:
        "Hire a CRM RevOps Architect to engineer scalable CRM systems, automated pipelines, and revenue operations infrastructure for agencies and coaches.",
      path: "/CRM-revops-architect",
      keywords:
        "CRM RevOps architect, CRM automation, revenue operations, CRM systems engineer, pipeline automation, CRM consultant Philippines",
      schema: [
        serviceSchema({
          name: "CRM RevOps Architecture",
          description:
            "Scalable CRM systems, automated pipelines, and revenue operations infrastructure for agencies and coaches.",
          path: "/CRM-revops-architect",
          serviceType: [
            "CRM Architecture",
            "Pipeline Automation",
            "Revenue Operations Infrastructure",
          ],
        }),
        breadcrumbSchema([
          { name: "Home", path: "" },
          { name: "CRM RevOps Architect", path: "/CRM-revops-architect" },
        ]),
        faqPageSchema(faqs),
      ],
    }),
  component: ServiceRevOps,
});
